<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    :fill="color"
    xmlns="http://www.w3.org/2000/svg"
    :style="{ color }"
  >
    <path
      d="M10 0.5L7.52763 7.6033L0 7.75699L6.00061 12.3011L3.81983 19.5L10 15.2044L16.1802 19.5L14.0002 12.3011L20 7.75699L12.4724 7.60407L10 0.5Z"
    ></path>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'StarSVG',
  props: {
    size: VueTypes.number.isRequired,
    color: VueTypes.string.isRequired,
  },
};
</script>

<style></style>
